<template>
  <a
    :href="href"
    class="tutorial-help-link"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="آموزش این بخش (در صفحه جدید)"
    title="آموزش این بخش (در صفحه جدید)"
  >
    <span class="icon-help-with-circle" aria-hidden="true"></span>
  </a>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'TutorialHelpLink',
  setup() {
    const route = useRoute()
    const href = computed(() => {
      const base = process.env.VUE_APP_LANDING_BASE_URL || 'https://irani-bank.com/'
      const url = new URL('tutorials.html', base.replace(/\/?$/, '/'))
      if (route.meta.tutorialSection) url.searchParams.set('section', route.meta.tutorialSection)
      return url.href
    })
    return { href }
  }
}
</script>

<style scoped>
.tutorial-help-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  font-size: 24px;
  color: #5186dd;
  border-radius: 50%;
}
.tutorial-help-link:hover { color: #2146a0; background: rgba(81, 134, 221, .1); }
.tutorial-help-link:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
.tutorial-help-link.login-info { font-size: 30px; }
:global(#change_mode.dark) .tutorial-help-link,
:global(body.dark-theme) .tutorial-help-link { color: #93baff; }
</style>
